module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"close_today":"今日不再显示"}}')
  delete Component.options._Ctor
}
